module.exports = shared.jqueryUi;